"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resendResetPasswordEmailFailure = exports.resendResetPasswordEmailSuccess = exports.resendResetPasswordEmailRequest = exports.resendVerifyEmailFailure = exports.resendVerifyEmailSuccess = exports.resendVerifyEmailRequest = exports.resetPasswordSuccessAction = exports.resetPasswordFailureAction = exports.resetPasswordValidation = exports.resetPasswordRequestAction = exports.setResetPasswordConfirmPasswordAction = exports.setResetPasswordAction = exports.validateData = void 0;
const ActionTypes = require("../../actionTypes/auth/resetPassword");
const validateData = (payload) => {
    return {
        type: ActionTypes.VALIDATE_DATA,
        payload
    };
};
exports.validateData = validateData;
const setResetPasswordAction = (password) => {
    return {
        type: ActionTypes.SET_RESET_PASSWORD,
        payload: password
    };
};
exports.setResetPasswordAction = setResetPasswordAction;
const setResetPasswordConfirmPasswordAction = (password) => {
    return {
        type: ActionTypes.SET_RESET_PASSWORD_CONFIRM_PASSWORD,
        payload: password
    };
};
exports.setResetPasswordConfirmPasswordAction = setResetPasswordConfirmPasswordAction;
const resetPasswordRequestAction = (mode, code, password, confirmPassword, email, language) => {
    return {
        type: ActionTypes.RESET_PASSWORD_REQUEST,
        payload: {
            mode,
            code,
            password,
            confirmPassword,
            email,
            language
        }
    };
};
exports.resetPasswordRequestAction = resetPasswordRequestAction;
const resetPasswordValidation = (error) => {
    return {
        type: ActionTypes.RESET_PASSWORD_VALIDATION,
        payload: error
    };
};
exports.resetPasswordValidation = resetPasswordValidation;
const resetPasswordFailureAction = (errorMessage) => {
    return {
        type: ActionTypes.RESET_PASSWORD_FAILURE,
        payload: errorMessage
    };
};
exports.resetPasswordFailureAction = resetPasswordFailureAction;
const resetPasswordSuccessAction = () => {
    return {
        type: ActionTypes.RESET_PASSWORD_SUCCESS
    };
};
exports.resetPasswordSuccessAction = resetPasswordSuccessAction;
// RESEND VERIFY MAIL
const resendVerifyEmailRequest = (email) => ({
    type: ActionTypes.RESEND_VERIFY_EMAIL_REQUEST,
    payload: email
});
exports.resendVerifyEmailRequest = resendVerifyEmailRequest;
const resendVerifyEmailSuccess = () => ({
    type: ActionTypes.RESEND_VERIFY_EMAIL_SUCCESS
});
exports.resendVerifyEmailSuccess = resendVerifyEmailSuccess;
const resendVerifyEmailFailure = (payload) => ({
    type: ActionTypes.RESEND_VERIFY_EMAIL_FAILURE,
    payload
});
exports.resendVerifyEmailFailure = resendVerifyEmailFailure;
// RESEND RESET PASSWORD MAIL
const resendResetPasswordEmailRequest = (email, code) => ({
    type: ActionTypes.RESEND_RESET_PASSWORD_EMAIL_REQUEST,
    payload: {
        email,
        code
    }
});
exports.resendResetPasswordEmailRequest = resendResetPasswordEmailRequest;
const resendResetPasswordEmailSuccess = () => ({
    type: ActionTypes.RESEND_RESET_PASSWORD_EMAIL_SUCCESS
});
exports.resendResetPasswordEmailSuccess = resendResetPasswordEmailSuccess;
const resendResetPasswordEmailFailure = (payload) => ({
    type: ActionTypes.RESEND_RESET_PASSWORD_EMAIL_FAILURE,
    payload
});
exports.resendResetPasswordEmailFailure = resendResetPasswordEmailFailure;
//# sourceMappingURL=resetPassword.js.map